import { FC } from "react";
import { resolveApplicationStar } from "@/src/utils/applications/resolveApplicationStar";

interface ApplicationStarIconProps {
  color: string | null | undefined;
}

const ApplicationStarIcon: FC<ApplicationStarIconProps> = ({ color }) => {
  const { Icon } = resolveApplicationStar(color);
  return <Icon />;
};

export default ApplicationStarIcon;
